<template>
<div class="container">
  <img id="leftarrow" src="@/assets/img/left.png" @click="decr" class="customarrow"/>
  <div id="show">
    <img :src="getImgUrl(data[index])"/>
  </div>
  <img id="rightarrow" src="@/assets/img/right.png" @click="incr" class="customarrow"/>
  <div id="count">
    <!-- <h1>{{this.index + 1}}/{{this.data.length}}</h1> -->
    <img :style="circleclass" v-for="img, id in data" :key="id" :src="circle(id)" @click="changeIndex(id)"/>
  </div>
</div>
</template>
<script>
export default {
  name: 'slide',
  props: {
    data: {
      required: true,
      type: Array,
    },
    small: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      index: 0,
    }
  },
  methods: {
    getImgUrl(pic) {
      return require('../assets/img/'+pic)
    },
    incr() {
      if( this.index < this.data.length-1 ) {
        this.index++;
      }
    },
    decr() {
      if( this.index > 0 ) {
        this.index--;
      }
    },
    circle(id) {
      if(this.index == id) {
        return require('../assets/img/filled.png');
      } else {
        return require('../assets/img/empty.png');
      }
    },
    changeIndex(id) {
      this.index = id;
    }
  },
  computed: {
    circleclass: function() {
      console.log('comp');
      if(this.small == true) {
        console.log('small');
        return { cursor: 'pointer', width: '25px'};
      } else {
        console.log('bigg');
        return {cursor: 'pointer', width: '40px'};
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import '../assets/css/definitions';
  .container {
    position: relative;
    height: 75%;
  }
  #show {
    // width: 700px;
    // height: 500px;
    //padding: 20px;
    height: 100%;
    width: 100%;
    background: $color-text-wh;
    align-content: center;
    img {
      width: 100%;
      height: 100%;
      //margin-left: 5%;
    }
  }

  #leftarrow {
    position: absolute;
    left: 15px;
    top: 45%;
    cursor: pointer;
  }
  #rightarrow {
    position: absolute;
    right: 15px;
    top: 45%;
    cursor: pointer;
  }

  #count {
    position: absolute;
    bottom: 0;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }

  .customarrow {
    background: rgba(255, 255, 255, 0.301)
  }
  .customarrow:hover {
    background: rgba(100, 100, 100, 0.301)
  }

</style>

